import Blogview from "../Previews/Ship/Terms/Blogview";

export const safetyDetails = {
  form: [
    {
      title: "Page Name",
      key: "page_name",
      className: "col-lg-12",
      type: "input",
    },
    {
      title: "Meta Description",
      key: "meta_description",
      className: "col-lg-12",
      type: "input",
    },
  ],
  component: [
    {
      type: 5,
      fields: [
        {
          title: "English Header",
          key: "description",
          className: "col-lg-3",

          type: "editor",
          height: "300px",
        },
        {
          title: "Simplified Chinese Header",
          key: "simplified_chinese_description",
          className: "col-lg-3",

          type: "editor",
          height: "300px",
        },
        {
          title: "Traditional Chinese Header",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },
        {
          title: "Bahasa Header",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },
        {
          title: "Page File",
          key: "image",
          filetype: "all",
          className: "col-lg-3",
          placeholder: "Upload Page File",
          type: "file",
          maxSize: "10 MB",
        },
        {
          title: "Simplified Chinese Page File",
          key: "simplified_chinese_image",
           filetype: "all",
          className: "col-lg-3",
          placeholder: "Upload Simplified Chinese Page File ",
          type: "file",
          maxSize: "10 MB",
        },
        {
          title: "Traditional Chinese Page File",
          key: "traditional_chinese_image",
          className: "col-lg-3",
           filetype: "all",
          placeholder: "Upload Traditional Chinese Page File",
          type: "file",
          maxSize: "10 MB",
        },
        {
          title: "Bahasa Page File",
          key: "bahasa_image",
          filetype: "all",
          className: "col-lg-3",
          placeholder: "Upload Bahasa Page File",
          type: "file",
          maxSize: "10 MB",
        },

        {
          title: "English Footer",
          key: "description1",
          className: "col-lg-3",
          type: "html",
          type: "editor",
          height: "300px",
        },
        {
          title: "Simplified Chinese Footer",
          key: "simplified_chinese_description1",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },
        {
          title: "Traditional Chinese Footer",
          key: "traditional_chinese_description1",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },
        {
          title: "Bahasa Footer",
          key: "bahasa_description1",
          className: "col-lg-3",
          type: "editor",
          height: "300px",
        },
      ],
      preview: (activetab, cardData) => (
        <Blogview activetab={activetab} cardData={cardData} />
      ),
    },
  ],
};
